module.exports = __webpack_public_path__ + "static/media/YogaTiger.1c5105cb.jpg";